
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro/category/[...slug]",
      function () {
        return require("private-next-pages/pro/category/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro/category/[...slug]"])
      });
    }
  